export default function ShowCurrencySymbol(currency) {
  if (currency === 'EUR') return '€';
  if (currency === 'GBP') return '£';
  return '$';
}
